import { Skeleton } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import './ImageWithSkeleton.scss';

export interface ImageWithSkeletonProps {
    src?: string;
    className?: string;
    imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
}

const ImageWithSkeleton = ({ src, className, imgProps }: ImageWithSkeletonProps): JSX.Element => {
    const [isImageLoading, setIsImageLoading] = useState(true);

    useEffect(() => {
        setIsImageLoading(true);
    }, [src]);

    return (
        <div className={classNames('ImageWithSkeleton', className)}>
            <img
                {...imgProps}
                src={src}
                className={classNames('ImageWithSkeleton__image', imgProps?.className, {
                    'ImageWithSkeleton__image--hidden': isImageLoading,
                })}
                onLoad={() => setIsImageLoading(false)}
            />
            {isImageLoading && <Skeleton.Image active className="ImageWithSkeleton__skeleton" />}
        </div>
    );
};

export default ImageWithSkeleton;
